import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'

import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'

import compositionsMiddleware from 'models/compositions/middleware'
import locationMiddleware from 'models/location/middleware'
import ratingsMiddleware from 'models/ratings/middleware'
import trackingMiddleware from 'models/tracking/middleware'
import userMiddleware from 'models/user/middleware'
import furnitureMiddleware from 'models/furniture/middleware'
import iFrameMiddleWare from 'models/iFrame/middleware'
import previewMiddleWare from 'models/preview/middleware'
import localStorageMiddleware from 'models/localStorage/middleware'

import { getRoutingBasename } from 'models/location/selectors'

import createRootReducer from 'models/reducers'
import createSagaMiddleware from 'redux-saga'
import rootSaga from 'models/sagas'

import type { RootState } from 'store'

const sagaMiddleware = createSagaMiddleware()
const loggerMiddleware = createLogger()

/* eslint-disable-next-line no-underscore-dangle */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
export const history = createBrowserHistory({ basename: getRoutingBasename() })
export const rootReducer = createRootReducer(history)

export default function configureStore(initialState?: RootState) {
    const store = createStore(
        rootReducer,
        initialState,
        composeEnhancers(
            applyMiddleware(
                thunkMiddleware,
                previewMiddleWare,
                iFrameMiddleWare,
                localStorageMiddleware,
                furnitureMiddleware,
                compositionsMiddleware,
                userMiddleware,
                ratingsMiddleware,
                locationMiddleware,
                trackingMiddleware,
                sagaMiddleware,
                loggerMiddleware,
                routerMiddleware(history),
            ),
        ),
    )
    sagaMiddleware.run(rootSaga)
    return store
}
